import React from "react";
import Chart from "react-apexcharts";

interface TrafficSourcesProps {
  title?: string;
  data: any;
  type?:
  | "line"
  | "area"
  | "bar"
  | "histogram"
  | "pie"
  | "donut"
  | "radialBar"
  | "scatter"
  | "bubble"
  | "heatmap"
  | "treemap"
  | "boxPlot"
  | "candlestick"
  | "radar"
  | "polarArea"
  | "rangeBar";
  options?: any;
  labels?: any;
  colors: any;
  classname?: string;
  customScale?: any;
}


const TrafficSources = ({
  data,
  type = "donut",
  labels = [],
  options,
  colors,
  classname,
  customScale = 0.5
}: TrafficSourcesProps) => {

  const defaultOptions = {
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        customScale: customScale,
        donut: {
          size: "50%",
        },
      },
      stroke: {
        colors: undefined,
      },
    },
    colors: colors,
    legend: {
      show: false, // Hide default legend
    },
  };
  return (
    <div className={"traffic-sources-container " + classname}>
      <div className="custom-pie-chart">
      <Chart
        className= "piechart-dashboard"
        series={data}
        type={type as any}
        height={250}
        options={Object.assign({}, defaultOptions, options, { labels })}
      />
      </div>
      <div className="custom-legend">
        {labels.map((label, index) => (
          <div key={index} className="legend-item legend-item-traffic">
            <span>
              <span
                className="legend-color"
                style={{ backgroundColor: defaultOptions.colors[index] }}
              ></span>
              <span className="legend-label">{label}</span>
            </span>
            <span className="legend-value">{data[index]}h</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrafficSources;
